import { jwtDecode } from 'jwt-decode';
import { LocalStorageKeys } from '../../core/constants/localStorageKeys.enum';
import { Role } from '../roles/role';
import { Roles } from '../roles.enum';

export class JwtUtils {
    private static get JWT() {
        const accessToken = localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN);
        if (!accessToken) {
            return null;
        }

        return jwtDecode(accessToken);
    }

    public static get accessToken(): string {
        return localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN);
    }

    public static get refreshToken(): string {
        return localStorage.getItem(LocalStorageKeys.REFRESH_TOKEN);
    }

    public static getRoles(): Array<Role> {
        if (!this.JWT) {
            return [];
        }

        const rolesVal = this.JWT['UserRoles'];
        const rolesArray = [];

        if (Array.isArray(rolesVal)) {
            rolesVal.forEach(x => rolesArray.push(JSON.parse(x)))
        } else {
            rolesArray.push(JSON.parse(rolesVal));
        }

        const propCasingFixed = rolesArray.map(r => ({ id: r['Id'], name: r['Name'], description: '', isExpanded: false } as Role));
        return propCasingFixed;
    }

    public static getRoleIds(): Array<number> {
        return this.getRoles().map(x => x.id);
    }

    public static getRoleNames(): Array<string> {
        return this.getRoles().map(x => x.name);
    }

    public static hasRoleById(roleId: number) {
        return this.getRoleIds().includes(roleId);
    }

    public static hasRoleByName(role: Roles) {
        return this.getRoleNames().includes(role);
    }

    public static hasSupersedingDocumentRole(): boolean {
        return this.hasRoleByName(Roles.Developer)
            || this.hasRoleByName(Roles.PortalAdmin)
            || this.hasRoleByName(Roles.TsAdmin);
    }

    public static getUserName(): string {
        if (!this.JWT) {
            return '';
        }

        return this.JWT['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    }

    public static get secondsUntilTokenExpires(): number {
        return this.JWT
            ? (this.JWT.exp * 1000 - Date.now()) / 1000
            : 0;
    }

    public static isTokenExpired(): boolean {
        try {
            return this.JWT
                ? Date.now() > this.JWT.exp * 1000
                : true;
        } catch (e) {
            console.error('Error caught decoding jwt', e);
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/utilities/jwtUtils.ts